(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda-day-part
    module.controller('AgendaDayPartController',
        [AgendaDayPartControllerFn]);

    function AgendaDayPartControllerFn() {
        var vm = this;

        activate();


        // collapse
        vm.collapse = function () {
            vm.part.data.collapsed = !vm.part.data.collapsed; // direct set
        };
                           

        // activation work
        function activate() {                   
        } // activate

    }

})();